<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn class="ma-2" v-on="on" v-if="admin" :id="id" icon>
        <v-icon>delete</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title grey lighten-2" primary-title>{{$t('DataHome.Dialog.delete')}}</v-card-title>
      <v-card-text class="mt-5">{{$t('DataHome.Dialog.description-delete')}}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">{{$t('DataHome.back')}}</v-btn>
        <v-btn color="primary" text @click="deleteDevice">{{$t('DataHome.sure')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    admin: Boolean,
    id: String,
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    deleteDevice: function() {
      this.dialog = false;
      this.$emit("deletedevice",this.id);
    }
  }
};
</script>